import type { FC } from 'react';
import * as Styled from './styled';
import type { TagProps } from './types';

export * from './types';

export const Tag: FC<TagProps> = (props) => {
  const { children, color, backgroundColor, onClick } = props;

  return (
    <Styled.Tag
      color={color}
      backgroundColor={backgroundColor}
      onClick={onClick}
      clickable={(!!onClick).toString()}
    >
      {children}
    </Styled.Tag>
  );
};
